import { initializeApp } from 'firebase/app';
import { getFirestore, Timestamp } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyC_Wp39MKNprlE2jkaeMIRDIXjhkcnoeSk',
  authDomain: 'mefarsemim-net.firebaseapp.com',
  projectId: 'mefarsemim-net',
  storageBucket: 'mefarsemim-net.firebasestorage.app',
  messagingSenderId: '571256644653',
  appId: '1:571256644653:web:15007978428259193e04a4',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export { Timestamp };

